import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';
import { earlyLoanRepayment } from './configByFeature/earlyLoanRepayment/RO';

export const loans: DeepPartial<LoanFeatureConfig> = {
    overview: {
        enabled: true,
        showTransactions: true,
        showAdditionalInfo: true,
        showEarlyLoanRepaymentActionButton: true,
        showLoanCurrency: true,
        displayDedicatedMortgageInfos: true,
    },
    additionalDetails: {
        showOverdueInfo: true,
        showExtraInstallment: true,
    },
    transactions: {
        enabled: true,
        mode: 'always',
    },
    statements: {
        enabled: true,
        mode: 'flag',
        showMultiDownloadCard: true,
        showNewCustomStatementCard: true,
    },
    settingsDetails: {
        displayAccountOwner: true,
        displayPlainAccountNumber: true,
        displayBIC: true,
    },
    earlyLoanRepayment,
    layout: {
        productInfo: {
            formatAccountNumber: true,
        },
    },
};
